import { defineAction } from '~/prix'
import { z } from 'zod'
import veterinarianFetchAction from './veterinarianFetch.action.json' with { type: 'json' }
import { veterinarianObject } from '../veterinarianObject'
import { citizenObject } from '~/packages/general/citizen/citizenObject'

const veterinarianFetchDefinition = defineAction({
  ...veterinarianFetchAction,

  input: veterinarianObject
    .pick({
      id: true,
    })
    .extend({ includeInactivated: z.boolean().optional() }),
  output: veterinarianObject.extend({
    citizen: citizenObject,
  }),
})

export default veterinarianFetchDefinition
